'use strict';

module.exports = ['$scope', 'ModalSvc', 'InvitationSvc', 'toastr', function ($scope, ModalSvc, InvitationSvc, toastr) {

    $scope.addEmployee = function (organization) {
        var modalInstance = ModalSvc.inviteUser.open({
            organization: organization,
            showWarning: true
        });

        modalInstance.result.then(function (data) {
            if (data.action == 'invited') {
                toastr.success('The invitation has been sent to the user.');
            }
            if (data.action == 'added') {
                toastr.success(`The user has been added to the plant.`);
            }
            $scope.addedMember = data;

            fetchData();
        });
    };

    $scope.removeInvitation = function (invitation) {
        InvitationSvc.delete(invitation, invitation.to_group).then(function () {
            fetchData();
        });
    };

    // ------------------
    // Load Dependent Data
    // ------------------
    function fetchData() {
        InvitationSvc.list_pending().success((data) => {
            data.forEach(function (item) {
                item.date_invited = moment(item.date_invited).format($scope.$root.dateFormat.moment);
            });
            $scope.pending_invitations = data;
        });
    }

    // ------------------
    // Initialization
    // ------------------
    fetchData();

}];